import React from 'react';
import { Controller } from 'react-hook-form';
import { Toggle as GuiToggle } from '@oliasoft-open-source/react-ui-library';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const RawToggle = ({ testId, name, label, control, disabled = false, onChange = null }) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => {
      const { onChange: fieldOnChange, value, ...props } = field;
      delete props.ref;

      return (
        <GuiToggle
          {...props}
          testId={testId}
          checked={value}
          label={label}
          disabled={disabled}
          onChange={(e) => {
            fieldOnChange(e);
            if (onChange) {
              onChange(e);
            }
          }}
        />
      );
    }}
  />
);

export const Toggle = withErrorBoundary(RawToggle);
